/* import __COLOCATED_TEMPLATE__ from './topic-tracking.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./topic-tracking.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());